import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22fraunces.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22../lib/style-guide/font-assets/upstream/fraunces-latin-normal.woff2%22,%22weight%22:%22400%20600%22,%22style%22:%22normal%22},{%22path%22:%22../lib/style-guide/font-assets/upstream/fraunces-latin-italic.woff2%22,%22weight%22:%22400%20600%22,%22style%22:%22italic%22}],%22variable%22:%22--font-fraunces%22,%22display%22:%22swap%22,%22preload%22:false,%22adjustFontFallback%22:%22Times%20New%20Roman%22}],%22variableName%22:%22fraunces%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'fraunces', 'fraunces Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
